import store from "@/store/";

function startFunctionRequest(endpoint) {
	// URL to Express Middleware that validates JWT token for all requests
	// Webpack process.env is in /build/webpack.*.confi.js
	let cloudfunctionsUrl = process.env.FIREBASE_CLOUDFUNCTIONS_URL + endpoint;
	// console.log('Building request to', cloudfunctionsUrl, 'with ID token in Authorization header.')
	let req = new XMLHttpRequest();
	req.onload = function () {
		// console.log('API Request - Started')
	};
	req.onerror = function () {
		console.log("onerror - responseText: ", req.responseText);
	};
	req.open("GET", cloudfunctionsUrl, true);
	req.setRequestHeader("Authorization", "Bearer " + store.getters.token);
	return req;
}

function syncApis() {
	let req = startFunctionRequest("/syncApis");
	req.onload = function () {
		// console.log('API Request - syncApis: Complete')
		// console.log('onload - responseText: ', req.responseText)
	};
	req.send();
}

function postToday() {
	let req = startFunctionRequest("/postToday");
	req.onload = function () {
		// console.log('API Request - postToday: Complete')
		// console.log('onload - responseText: ', req.responseText)
	};
	req.send();
}

function updatePersonsGSuiteStatus() {
	let req = startFunctionRequest("/updatePersonsGSuiteStatus");
	req.onload = function () {
		// console.log('API Request - updatePersonsGSuiteStatus: Complete')
		// console.log('onload - responseText: ', req.responseText)
	};
	req.send();
}

function postGroupsData() {
	let req = startFunctionRequest("/postGroupsData");
	req.onload = function () {
		// console.log('API Request - postGroupsData: Complete')
		// console.log('onload - responseText: ', req.responseText)
	};
	req.send();
}
function postUpdateSheet() {
	let req = startFunctionRequest("/postUpdateSheet");
	req.onload = function () {
		// console.log('API Request - postUpdateSheet: Complete')
		// console.log('onload - responseText: ', req.responseText)
	};
	req.send();
}
function postSignatoryStatus() {
	let req = startFunctionRequest("/postSignatoryStatus");
	req.onload = function () {
		// console.log('API Request - postSignatoryStatus: Complete')
		// console.log('onload - responseText: ', req.responseText)
	};
	req.send();
}
function postOnsipUsers() {
	let req = startFunctionRequest("/postOnsipUsers");
	req.onload = function () {
		// console.log("API Request - postOnsipUsers: Complete");
		// console.log("onload - responseText: ", req.responseText);
	};
	req.send();
}
function postSlackActiveUsers() {
	let req = startFunctionRequest("/postSlackActiveUsers");
	req.onload = function () {
		// console.log('API Request - postSlackActiveUsers: Complete')
		// console.log('onload - responseText: ', req.responseText)
	};
	req.send();
}
function updateSlackActiveUsersPublicChannels() {
	let req = startFunctionRequest("/updateSlackActiveUsersPublicChannels");
	req.onload = function () {
		// console.log('API Request - postSlackActiveUsers: Complete')
		// console.log('onload - responseText: ', req.responseText)
	};
	req.send();
}
function postDates() {
	let req = startFunctionRequest("/postDates");
	req.onload = function () {
		// console.log('API Request - setDate: Complete')
		// console.log('onload - responseText: ', req.responseText)
	};
	req.send();
}

export {
	syncApis,
	postToday,
	postUpdateSheet,
	postSignatoryStatus,
	updatePersonsGSuiteStatus,
	postGroupsData,
	postOnsipUsers,
	postSlackActiveUsers,
	updateSlackActiveUsersPublicChannels,
	postDates
};



// WEBPACK FOOTER //
// ./src/vue-service-api.js